import axiosInstance from "./axios.instance";

/**
 * TAG CRUD
 */
export const API_GET_ALL_TAGS = async () => {
  const res = await axiosInstance.get("/tag");
  return res.data?.data || [];
};

export const API_CREATE_TAG = async (payload) => {
  const res = await axiosInstance.post("/tag", payload);
  return res.data?.data;
};

export const API_UPDATE_TAG = async (id, payload) => {
  const res = await axiosInstance.put(`/tag/${id}`, payload);
  return res.data?.data;
};

export const API_DELETE_TAG = async (id) => {
  const res = await axiosInstance.delete(`/tag/${id}`);
  return res.data;
};

/**
 * TAG ASSIGNMENT
 */
export const API_ASSIGN_TAG_TO_CUSTOMER = async (payload) => {
  const res = await axiosInstance.post("/tag/assign", payload);
  return res.data;
};

export const API_REMOVE_TAG_FROM_CUSTOMER = async (payload) => {
  const res = await axiosInstance.post("/tag/remove", payload);
  return res.data;
};

export const API_GET_ASSIGNED_TAGS_BY_CUSTOMER = async (customerMobile) => {
  const res = await axiosInstance.get(
    `/tag/assigned-by-phone?customerMobile=${customerMobile}`
  );
  return res.data?.assignedTagIds || [];
};
